import React from 'react';
import EditorJS from '@editorjs/editorjs';

import { DevelopmentComponent } from '../..';
import ImageInstructionComponent from './image-instruction/ImageInstructionComponent';
import TextInstructionComponent from './text-instruction/TextInstructionComponent';
import NoteInstructionComponent from './note-instruction/NoteInstructionComponent';
import VideoInstructionComponent from './video-instruction/VideoInstructionComponent';
import TitleInstructionComponent from './title-instruction/TitleInstructionComponent';
import NameScriptInstructionComponent from './name-script-instruction/NameScriptInstructionComponent';
import DocumentInstructionComponent from './document-page-instruction/DocumentInstructionComponent';
import AudioInstructionComponent from './audio-instruction/AudioInstructionComponent';
// import WebPageInstructionComponent from './webpage-instruction/WebPageInstructionComponent';

type Props = {
  instanceEditor: EditorJS | undefined;
  refEditor: HTMLDivElement | null;
};

const InstructionContainer = ({ instanceEditor, refEditor }: Props) => {

  return (
    <DevelopmentComponent enableDev enableProd enableStaging>
      <ImageInstructionComponent instanceEditor={instanceEditor} refEditor={refEditor} />
      <TextInstructionComponent instanceEditor={instanceEditor} refEditor={refEditor} />
      <NoteInstructionComponent instanceEditor={instanceEditor} refEditor={refEditor} />
      <VideoInstructionComponent instanceEditor={instanceEditor} refEditor={refEditor} />
      <TitleInstructionComponent instanceEditor={instanceEditor} refEditor={refEditor} />
      <NameScriptInstructionComponent instanceEditor={instanceEditor} refEditor={refEditor} />
      <DocumentInstructionComponent instanceEditor={instanceEditor} refEditor={refEditor} />
      <AudioInstructionComponent instanceEditor={instanceEditor} refEditor={refEditor} />
      {/*<WebPageInstructionComponent instanceEditor={instanceEditor} refEditor={refEditor} />*/}
    </DevelopmentComponent>
  );
};

export default InstructionContainer;
